export default "__VITE_ASSET__CIGb1QuW__"